module.exports = __webpack_public_path__ + "img/400.740eed70.svg";